<template>
  <div class="flex items-center">
    <vs-chip :color="color">{{ text }}</vs-chip>
  </div>
</template>

<script>
  export default {
    name: 'CRStatus',
    computed: {
      text() {
        return this.$data.data.statusName;
      },
      color() {
        return (this.$data.data.statusName.substr(0, 3).toUpperCase() == 'ACT') ? 'success' : 'danger';
      }
    }
  }
</script>
